<!-- src/components/Reportes/MermasVenaScrap/components/MVSTablaTotales.vue -->
<template>
  <aside class="mvs-tabla-totales">
    <h3 class="mvs-tabla-totales__titulo">
      Control de mermas en inyección en Kg
      <span class="mvs-tabla-totales__subtitulo">(Vena, Scrap)</span>
    </h3>

    <div class="mvs-tabla-totales__scroll">
      <table class="mvs-tabla-totales__tabla">
        <thead>
          <tr>
            <th>Periodo</th>
            <th>Scrap</th>
            <th>Vena</th>
            <th>Total</th>
            <th>vs. anterior</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="fila in filas"
            :key="fila.etiqueta"
            :class="{ 'mvs-tabla-totales__fila--actual': fila.esActual }"
          >
            <td>{{ fila.etiqueta }}</td>
            <td>{{ formatearKg(fila.scrap) }}</td>
            <td>{{ formatearKg(fila.vena) }}</td>
            <td>{{ formatearKg(fila.total) }}</td>
            <td>
              <span
                v-if="fila.variacionScrap !== null"
                class="mvs-tabla-totales__variacion"
                :class="
                  fila.variacionScrap > 0
                    ? 'mvs-tabla-totales__variacion--up'
                    : 'mvs-tabla-totales__variacion--down'
                "
              >
                {{ fila.variacionScrap > 0 ? "↑" : "↓" }}
                {{ formatearKg(Math.abs(fila.variacionScrap)) }}
              </span>
              <span v-else class="mvs-tabla-totales__sin-dato">—</span>
            </td>
          </tr>
          <tr v-if="!filas.length">
            <td colspan="5" class="mvs-tabla-totales__vacio">Sin datos disponibles</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-if="nota" class="mvs-tabla-totales__nota">{{ nota }}</p>
  </aside>
</template>

<script setup>
defineProps({
  // [{ etiqueta, scrap, vena, total, variacionScrap, esActual }]
  // variacionScrap = scrap del periodo - scrap del periodo anterior.
  // > 0 -> el scrap subió (flecha roja hacia arriba)
  // <= 0 -> el scrap bajó o se mantuvo (flecha verde hacia abajo)
  filas: { type: Array, default: () => [] },
  nota: { type: String, default: "" },
});

// Máximo 2 decimales (sin arrastrar errores de punto flotante tipo 69.09000000000001
// ni ceros innecesarios como "144.00" cuando es un entero exacto).
function formatearKg(valor) {
  if (valor === null || valor === undefined || Number.isNaN(valor)) return "0";
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(valor);
}
</script>
